import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"

export const fetchUsers = createAsyncThunk('users/fetchUsers', async ({
                                                                        limit,
                                                                        offset,
                                                                        searchQuery,
                                                                      }, { rejectWithValue }) => {
  try {

    const response = await apiRequest.get('/users', {
      params: {
        limit,
        offset,
        searchQuery,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contacts'
    return rejectWithValue(errorMessage)
  }
})

export const createNewUsers = createAsyncThunk('users/createUsers', async ({
                                                                             userData,
                                                                           }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/users`, userData)
    return response.data

  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const updateUsers = createAsyncThunk('users/updateUsers', async ({
                                                                          userData, userId
                                                                        }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/users/${userId}`, userData)
    return response.data

  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const getUsersById = createAsyncThunk('customers/getUsersById', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/users/${userId}`)
    return response.data


  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const getAllUsersSubRolesDropdown = createAsyncThunk('customers/getUsersSubRoles', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`users/sub-role/dropdown`)
    return response.data


  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const getAllUsersSubRoles = createAsyncThunk('customers/getUsersSubRoles', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/users/sub-role/info`)
    return response.data


  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const removeUser = createAsyncThunk('users/removeUsers', async (
  userId
  , { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/users/${userId}`)
    return response.data

  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const resendUserInvite = createAsyncThunk('users/resendUserInvite', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/users/${userId}/resend-invite`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to resend invitation'
    return rejectWithValue(errorMessage)
  }
})

export const adminResetPassword = createAsyncThunk('users/adminResetPassword', async ({
  userId, userType, mode
}, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/admin-reset-password', mode ? { userId, userType, mode } : { userId, userType })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to reset password'
    return rejectWithValue(errorMessage)
  }
})